import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import products from "../products";
import "../styles/ProductDetail.css";

function VideoPlayer({ videos }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleEnded = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  return (
    <div style={{ position: "relative", width: "100%", paddingTop: "133%", backgroundColor: "black" }}>
      <video
        src={videos[currentIndex]}
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "contain" }}
        controls
        muted
        playsInline
        preload="metadata"
        autoPlay
        onEnded={handleEnded}
      />
    </div>
  );
}

function ProductDetail() {
  const [toastMessage, setToastMessage] = useState("");
  const { slug } = useParams();
  const product = products.find((p) => p.slug === slug);

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [slug]);

  const addToCart = (product) => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];

    // Buscar si el producto ya está en el carrito
    const existingProduct = cart.find((item) => item.id === product.id);

    if (existingProduct) {
      existingProduct.quantity = (existingProduct.quantity || 1) + 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    localStorage.setItem("cart", JSON.stringify(cart));

    // Disparar evento para actualizar contador del header
    window.dispatchEvent(new Event("storage"));

    // Mostrar mensaje de éxito
    setToastMessage(`${product.name} añadido al carrito`);
    setTimeout(() => setToastMessage(""), 2000);
  };

  if (!product) {
    return (
      <section className="product-detail">
        <h2 className="product-title">Producto no encontrado</h2>
      </section>
    );
  }

  return (
    <section className="product-detail detail-section">
      <div className="detail-content">
        <div className="detail-image-wrapper">
          {product.video ? (
            Array.isArray(product.video) ? (
              <VideoPlayer videos={product.video} />
            ) : (
              <VideoPlayer videos={[product.video]} />
            )
          ) : (
            <img
              src={product.image}
              alt={product.name}
              className="detail-image"
            />
          )}
        </div>
        <div className="detail-info">
          <h1 className="detail-title">{product.name}</h1>
          <p className="detail-category">Categoría: {product.category}</p>
          {product.price > 0 && product.ISBN && (
            <p className="detail-isbn">ISBN: {product.ISBN}</p>
          )}
          {/* Si hay algo tipo “Free Shipping” */}
          {product.freeShipping && (
            <span className="detail-free-shipping">Envío gratis</span>
          )}
          <p className="detail-description">{product.description}</p>
          {product.price > 0 ? (
            <>
              <p className="detail-price">
                {(product.price / 100).toFixed(2)} €
              </p>
              <p className="detail-shipping-info">
                Gastos de envío: <strong>3.80 €</strong> (gratis en pedidos
                superiores a 60 €)
              </p>
              <button
                className="detail-buy-button"
                onClick={() => addToCart(product)}
              >
                Comprar
              </button>
            </>
          ) : (
            <div className="contact-banner">
              Contacte al teléfono 637 09 85 42
            </div>
          )}
        </div>
      </div>

      {/* Productos relacionados, usando otros productos del array */}
      <div className="related-products">
        <h2 className="related-title">Productos relacionados</h2>
        <div className="product-grid related-grid">
          {products
            .filter(
              (p) => p.slug !== product.slug && p.category === product.category
            )
            .slice(0, 3)
            .map((rel) => (
              <Link
                key={rel.id}
                to={`/producto/${rel.slug}`}
                className="product-card-link"
              >
                <div className="product-card">
                  <img
                    src={rel.image}
                    alt={rel.title}
                    className="product-image"
                  />
                  <div className="product-info">
                    <h3 className="product-title">{rel.name}</h3>
                  </div>
                  <footer className="product-footer">
                    {rel.price > 0 ? (
                      <>
                        <span className="product-price">
                          {(rel.price / 100).toFixed(2)} €
                        </span>
                        <button
                          className="buy-button"
                          onClick={(e) => {
                            e.preventDefault();
                            addToCart(rel);
                          }}
                        >
                          Comprar
                        </button>
                      </>
                    ) : (
                      <div className="contact-banner"></div>
                    )}
                  </footer>
                </div>
              </Link>
            ))}
        </div>
      </div>

      {toastMessage && <div className="toast">{toastMessage}</div>}
    </section>
  );
}

export default ProductDetail;
